import type { ICellRendererParams } from "ag-grid-enterprise";
import type { StrandLossByShift } from "../../models/StrandLossByShift";

const containerStyle = {
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
  columnGap: 4,
  lineHeight: 1.3,
} as const;

const partStyle = { whiteSpace: "nowrap" } as const;

export const DateTimeCell = ({
  value,
}: ICellRendererParams<StrandLossByShift, string>) => {
  if (!value) return null;
  const [date, time] = value.split(" ");

  return (
    <span style={containerStyle}>
      <span style={partStyle}>{date}</span>
      <span style={partStyle}>{time}</span>
    </span>
  );
};
